module.exports = __webpack_public_path__ + "img/11825381_L.2bafa7b7.png";